<template>
  <v-container>
    <PageHeader :title="name" />
    <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
      <v-card v-for="sourceType in sourceTypeValues" :key="`form-${sourceType}`">
        <Subheader :title="getSourceTypeName(sourceType)" no-search></Subheader>
        <v-card-text>
          Grouper Order:
          <v-menu offset-y>
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="on">
                {{ sideMenuSettingData[sourceType].OrderType }}
                <v-icon small right>keyboard_arrow_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="sideMenuSettingData[sourceType].OrderType = 'ASC'">
                <v-list-tile-title>ASC</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="sideMenuSettingData[sourceType].OrderType = 'DESC'">
                <v-list-tile-title>DESC</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card-text>
        <v-card-text class="pt-0">
          Grouper Type
          <v-combobox v-model="sideMenuSettingData[sourceType].GroupType" :items="getGroupTypeListBySourceType(sourceType)" solo chips label="Select grouping" multiple :rules="GroupTypeRule" persistent-hint hint="The label order is the grouping order" item-text="name" item-value="value">
            <template slot="selection" slot-scope="data">
              <v-chip :selected="data.selected" close class="chip--select-multi" @input="removeGroupTypeForSourceType(sourceType, data.item)">{{ data.item.name || data.item }}</v-chip>
            </template>
          </v-combobox>
        </v-card-text>
      </v-card>
      <v-card-actions>
        <v-btn class="centerBtn" color="success" @click="updateUserGroupSideMenuSetting()" :loading="isLoadingUpdate" :disabled="!valid">
          <v-icon class="mr-1">done</v-icon>
          {{ $t('Button.Save') }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-container>
</template>

<script>

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const navigation = createNamespacedHelpers('navigation')
  import {
    SOURCE_TYPES,
    SOURCE_TYPES_WITH_NAME,
  } from '@/store/MonitoringFeature/monitoringfeature'
  import {
    sourceGroupTypes,
  } from '@/store/UI/navigation'

  export default {
    components: {
    },
    props: {
      name: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        testData: [],
        testItems: [{ text: 'A', value: 'valA' }, { text: 'B', value: 'valB' }],
        ContinuousStationGroupTypeList: ['station_category', 'time_series_tag'],
        GroupTypeList: ['station_category', 'data_media_type'],
        GroupTypeRule: [v => (!!v && v.length > 0) || 'Grouper Type is required'],
        valid: true,
        ContinuousSettingData: {
          GroupType: [],
          OrderType: 'ASC',
        },
        SettingData: {
          GroupType: [],
          OrderType: 'ASC',
        },
        sideMenuSettingData: {
          [SOURCE_TYPES.discreteEnvirodata]: {
            GroupType: [],
            OrderType: 'ASC',
          },
          [SOURCE_TYPES.continuousAquarius]: {
            GroupType: [],
            OrderType: 'ASC',
          },
          [SOURCE_TYPES.vegetativeMonitoringEnvirodata]: {
            GroupType: [],
            OrderType: 'ASC',
          },
          [SOURCE_TYPES.surveysEnvirodata]: {
            GroupType: [],
            OrderType: 'ASC',
          },
        },
        isLoadingUpdate: false,
      }
    },
    async mounted() {
      await this.GetInitialData()
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      tenantData() {
        return this.roleList.find(x => x.RoleName == this.name)
      },
      tenantId() {
        return this.tenantData && this.tenantData.Id
      },
      sourceTypeValues() {
        return Object.values(SOURCE_TYPES)
      },
    },
    watch: {
      tenantId() {
        this.GetInitialData()
      },
    },
    methods: {
      ...admin.mapActions([
        'getUserGroupSideMenuSetting',
        'postUpdateUserGroupSideMenuSetting',
      ]),
      ...navigation.mapActions(['fetchSideMenu']),
      removeGroupTypeForSourceType(sourceType, item) {
        let sourceTypeGroupType = this.sideMenuSettingData[sourceType] && this.sideMenuSettingData[sourceType].GroupType
        if (!sourceTypeGroupType) {
          console.log(`cannot find side menu data for source type ${sourceType}`)
          return
        }
        const index = sourceTypeGroupType.indexOf(item)
        if (index >= 0) sourceTypeGroupType.splice(index, 1)
      },
      getGroupTypeListBySourceType(sourceType) {
        const groupTypeList = sourceGroupTypes[sourceType]
        return groupTypeList || []
      },
      getSourceTypeName(sourceType) {
        const sourceTypeName = SOURCE_TYPES_WITH_NAME.find(x => x.key == sourceType)
        return (sourceTypeName && sourceTypeName.dataType) || sourceType
      },
      convertGroupValuesToGroupItems(sourceType, groupTypeValues) {
        const groupTypeListForSourceType = this.getGroupTypeListBySourceType(sourceType)
        return groupTypeValues.map(groupTypeValue => {
          if (groupTypeValue.value) {
            return groupTypeValue
          }
          const groupType = groupTypeListForSourceType && groupTypeListForSourceType.find(x => x.value == groupTypeValue)
          return {
            name: (groupType && groupType.name) || groupTypeValue,
            value: groupTypeValue,
          }
        })
      },
      async GetInitialData() {
        let options = {
          data: this.tenantId,
          successCb: res => {
            let discreteSetting = res.data.find(x => x.SettingType == SOURCE_TYPES.discreteEnvirodata)
            let continuousSetting = res.data.find(x => x.SettingType == SOURCE_TYPES.continuousAquarius)
            this.SettingData = {
              GroupType: discreteSetting.GroupType,
              OrderType: discreteSetting.OrderType,
            }
            this.ContinuousSettingData = {
              GroupType: continuousSetting.GroupType,
              OrderType: continuousSetting.OrderType,
            }
            for (let i = 0; i < this.sourceTypeValues.length; i++) {
              let sourceType = this.sourceTypeValues[i]
              let apiSourceTypeData = res.data.find(x => x.SettingType == sourceType)
              this.setSideMenuDataForSourceType(sourceType, apiSourceTypeData)
            }
          },
        }
        this.getUserGroupSideMenuSetting(options)
      },
      setSideMenuDataForSourceType(sourceType, data) {        
        if (data) {
          let apiSourceGroupType = this.convertGroupValuesToGroupItems(sourceType, data.GroupType)
          this.sideMenuSettingData[sourceType] = {
            GroupType: apiSourceGroupType,
            OrderType: data.OrderType,
          }
        }
      },
      async updateUserGroupSideMenuSetting() {
        this.isLoadingUpdate = true
        const sourceTypeList = Object.keys(this.sideMenuSettingData)
        let updatePromises = []
        for (let i = 0; i < sourceTypeList.length; i++) {
          const sourceType = sourceTypeList[i]
          const sideMenuDataForSourceType = this.sideMenuSettingData[sourceType]
          let options = {
            data: {
              TenantId: this.tenantId,
              GroupType: sideMenuDataForSourceType.GroupType.map(x => x.value || x),
              OrderType: sideMenuDataForSourceType.OrderType,
              SettingType: sourceType,
            },
          }
          updatePromises.push(this.postUpdateUserGroupSideMenuSetting(options))
        }
        try {
          const updateResult = await Promise.all(updatePromises)
          updateResult.forEach(res => {
            this.setSideMenuDataForSourceType(res.data.SettingType, {
              GroupType: res.data.GroupType,
              OrderType: res.data.OrderType,
            })
          })
          const tenantBeingManagedIsAccountTenant = this.name == this.currentUserGroup.name
          if (tenantBeingManagedIsAccountTenant) {
            console.log('updating side menu')
            await this.fetchSideMenu({})
          }
          this.$store.dispatch('app/setSnackbar', {
            text: this.$t('AdministrationSideMenuDetail.updateFlagSuccessMsg'),
            color: 'success',
            icon: 'done',
          })
        } catch (error) {
          this.$store.dispatch('app/setSnackbar', {
            text: error,
            color: 'error',
            icon: 'error',
          })
        } finally {
          this.isLoadingUpdate = false
        }
      },
    },
  }
</script>

<style scoped>
  .page_title {
    margin-left: 0px !important;
  }

  .centerBtn {
    margin: 0 auto;
    display: block;
    width: 40%;
  }
</style>